registerComponent("sections/blog", function (component) {
/**
 * CENTRAL DE CONTEÚDOS — paginação por pontos para um trilho que já rola sozinho.
 *
 * A rolagem é CSS puro (`overflow-x` + `scroll-snap`), então arrastar com o dedo,
 * girar a roda e navegar por teclado já funcionam sem este script. O que ele
 * acrescenta é a leitura do estado:
 *
 *   · monta um ponto por cartão e marca o que está à vista;
 *   · clicar num ponto leva ao cartão correspondente;
 *   · escreve `data-depois` no trilho — é dele que sai o esmaecimento da borda,
 *     que some quando não há mais para onde ir.
 *
 * Os pontos só existem quando o trilho realmente rola: acima do degrau em que a
 * seção volta a ser grade, o CSS os esconde e o script não os marca.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

const FOLGA = 2;   /* tolerância de subpixel na ponta do trilho */

const trilho = component.querySelector('.blog__lista');
const listaPontos = component.querySelector('.blog__pontos');
const itens = trilho ? Array.from(trilho.children) : [];

if (trilho && listaPontos && itens.length > 1) {
    const rotulo = (i) => {
        const titulo = itens[i].querySelector('.artigo__chamada');
        return titulo ? titulo.textContent.trim() : `Conteúdo ${i + 1}`;
    };

    const pontos = itens.map((_, i) => {
        const item = document.createElement('li');
        const botao = document.createElement('button');

        botao.type = 'button';
        botao.className = 'blog__ponto';
        botao.setAttribute('aria-label', rotulo(i));
        botao.addEventListener('click', () => {
            trilho.scrollTo({ left: itens[i].offsetLeft - trilho.offsetLeft, behavior: 'smooth' });
            Asa.track('carousel_navigate', { target_id: 'blog', index: i, method: 'dot' });
        });

        item.append(botao);
        listaPontos.append(item);

        return botao;
    });

    const atualizar = () => {
        const rolavel = trilho.scrollWidth - trilho.clientWidth > FOLGA;

        trilho.dataset.depois = String(
            rolavel && trilho.scrollLeft < trilho.scrollWidth - trilho.clientWidth - FOLGA
        );

        // O item ativo é o que está mais perto da borda de partida do trilho.
        let ativo = 0;
        let menor = Infinity;

        itens.forEach((item, i) => {
            const d = Math.abs(item.offsetLeft - trilho.offsetLeft - trilho.scrollLeft);
            if (d < menor) { menor = d; ativo = i; }
        });

        pontos.forEach((ponto, i) => {
            if (i === ativo) ponto.setAttribute('aria-current', 'true');
            else ponto.removeAttribute('aria-current');
        });
    };

    trilho.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar, { passive: true });
    atualizar();
}

/* A entrada na rolagem (ADR 0051): as peças marcadas `.entrada` no HTML — ver
   `Asa.armarEntrada` em assets/.scripts/asa.js e assets/.styles/_entrada.less.
   Fora do bloco acima: não depende de o trilho rolar. */
Asa.armarEntrada([component], '.entrada');

});
